
prepare_form = ->
  button = document.querySelector('form .buttons button')
  document.querySelector('#agree_to_terms').addEventListener 'click', ->
    button.removeAttribute('disabled')

prepare_form() if document.body.getAttribute('id') == 'begin-free-trial'
